import { IconButton, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { ChevronRight, Info, Upgrade } from '@mui/icons-material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { pushAppRoute } from '../../data/domain/route-manager';
import { AppRoute } from '../../routes';
import { Status, UserRole } from '../../types';
import { StatusTag } from '../StatusTag/StatusTag';
import * as PXBColors from '@brightlayer-ui/colors';

import { MESH_TYPE } from '../../constants';
import { DeviceVendor, OTAReleaseDetails, OtaUpgradeStatus } from '../../types/device';

import { isRecordFound, useUserRoles } from '../../hooks/data-hooks';

const uselistStyles = makeStyles(() =>
    createStyles({
        statusStripe: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: 6,
            zIndex: 100,
            backgroundColor: PXBColors.red[500],
        },
    })
);

export const FlatListItem: React.FC<{
    item: {
        id: string;
        name: string;
        status?: Status;
        isEditable: boolean;
        childDevicesExpected?: boolean;
        showChildDeviceStatus?: boolean | null;
        vendor?: string;
        type?: string;
        parentId?: string;
        otaReleaseDetails?: OTAReleaseDetails | null;
        otaUpgradeStatus?: OtaUpgradeStatus | null;
        pxdbNavigation?: boolean;
    };
    navigate: AppRoute;
    subTitleData: string;
    hasStatus: boolean;
    infoClick?: Function;
    updateClick?: Function;
}> = (props) => {
    const history = useHistory();
    const classes = uselistStyles();
    const userRole = useUserRoles();

    const navigationTo = (): void => {
        if (props.item.isEditable && props.item.vendor?.toLowerCase() !== DeviceVendor.Wellaware) {
            pushAppRoute(history, props.navigate, 'LocationProfile');
        }
        if (props.item.pxdbNavigation) {
            pushAppRoute(history, props.navigate, 'PxDeviceProfile');
        }
        if (props.item.type === MESH_TYPE) {
            pushAppRoute(history, props.navigate, 'MeshDeviceProfile');
        }
        if (props.item.vendor === DeviceVendor.SFStarfishGateway) {
            pushAppRoute(history, props.navigate, 'StarfishDeviceProfile');
        }
        if (props.item.type === 'PxChildDeviceProfile') {
            pushAppRoute(history, props.navigate, 'PxChildDeviceProfile');
        }
        if (props.item.type === 'StarfishChildDeviceProfile') {
            pushAppRoute(history, props.navigate, 'StarfishChildDeviceProfile');
        }
    };
    const isEatonAdmin = isRecordFound(userRole)
        ? userRole.value.length === 1 && userRole.value[0].roleName === UserRole.EatonAdmin
        : false;

    return (
        <ListItem
            data-testid="list-item"
            key={props.item.id}
            onClick={navigationTo}
            style={{ marginTop: 10, backgroundColor: 'white', cursor: 'pointer' }}
        >
            {props.item.showChildDeviceStatus !== null && props.item.showChildDeviceStatus && (
                <div className={classes.statusStripe} data-test={'status-stripe'} />
            )}
            <ListItemText
                data-testid="list-item-text"
                primary={props.item.name}
                secondary={`${props.subTitleData}`}
                style={{ wordWrap: 'break-word', marginRight: 35 }}
            />
            {props.hasStatus && (
                <div style={{ width: '14%' }} data-testid="device-status">
                    <StatusTag status={props.item.status || Status.Active} style={{ marginRight: 5 }} />
                </div>
            )}

            {/*
                BLG will provide the type of gateway and based on that the release details will be shown.
                Every BLG's device type with starts with "BLG_Brightlayer_Gateway".
            */}
            <ListItemSecondaryAction>
                {props.item.type !== undefined &&
                    props.item.otaReleaseDetails !== null &&
                    props.item.type.toLowerCase().startsWith(DeviceVendor.SFStarfishGateway.toLowerCase()) &&
                    props.item.status === Status.Online &&
                    props.item.otaUpgradeStatus?.currentVersion !== null &&
                    props.item.otaUpgradeStatus?.currentVersion !== '' &&
                    props.item.otaUpgradeStatus?.currentVersion !== props.item.otaReleaseDetails?.version &&
                    props.navigate.type === 'StarfishDeviceProfile' &&
                    isEatonAdmin && (
                        <>
                            <Typography display="inline" fontSize={12} variant="body2">
                                {props.item.otaReleaseDetails?.version}
                            </Typography>

                            <IconButton
                                edge="end"
                                size="small"
                                data-testid="navigate-arrow"
                                onClick={(): void => {
                                    if (props.updateClick)
                                        props.updateClick(
                                            props.item.id,
                                            props.item.otaReleaseDetails,
                                            props.item.otaUpgradeStatus
                                        );
                                }}
                            >
                                <Upgrade />
                            </IconButton>
                        </>
                    )}
                {props.item.vendor === undefined ||
                ((props.item.vendor?.toLowerCase() === DeviceVendor.SierraWireless ||
                    props.item.vendor?.toLowerCase() === DeviceVendor.EatonCorporation ||
                    props.item.vendor?.toLowerCase() === 'eaton' ||
                    props.item.vendor === DeviceVendor.SFStarfishGateway) &&
                    props.item.parentId !== '') ? (
                    <IconButton edge="end" data-testid="navigate-arrow" onClick={navigationTo}>
                        <ChevronRight />
                    </IconButton>
                ) : (
                    <IconButton
                        edge="end"
                        data-testid="navigate-arrow"
                        onClick={(): void => {
                            if (props.infoClick) props.infoClick();
                        }}
                        size="large"
                    >
                        <Info />
                    </IconButton>
                )
                //)
                }
            </ListItemSecondaryAction>
        </ListItem>
    );
};
